<template>
  <w-input 
    ref="zInput"
    v-bind="$attrs"         
    class="mt2"
  />
</template>

<script>
export default {
  name: 'z-input',
  inheritAttrs: false,
  props: {
    name: String,
    
  },
  data() {
    return {
      
    }
  },
  watch: {
    "$page.props.errors" : {
      handler (val, oldval) {
        if(this.name) {
          // var xerr = eval(`this.$page.props.errors.${this.name}`)
          var xerr = []
          if(eval(`this.$page.props.errors.${this.name}`)) {
            xerr = eval(`this.$page.props.errors.${this.name}`)
          }
          // var xerr = eval(`this.$page.props.errors = {...this.$page.props.errors, ${this.name}: [] }`)
          if(xerr.length) {
            this.$refs.zInput.valid = false
            this.$refs.zInput.$refs.formEl.Validation.message = xerr[0]
          }
        }
      }
      
    }
  }
}
</script>

<style>

</style>